export enum MapElement {
  Marker,
}
